module.exports = __webpack_public_path__ + "img/logo.e3cb3483.png";